import src from "IMAGE";
export default { src, width: 24, height: 25, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
